import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import Meta from '../../../components/Meta';
import { LinkContainer } from 'react-router-bootstrap';

const Coupon = () => {
  return (
    <>
        <Meta>
            title='クーポンの利用方法について | ふるぷら'
            description='クーポンを利用する手順について説明するページです。'
            keywords={['ふるぷら', '古着', 'サブスク', 'クーポン']}
        </Meta>
        <Container className='my-5'>
            <Row className='justify-content-center'>
                <Col xs={12} md={8} lg={5}>
                    <section classname='coupon-top'></section>
                        <h1 className="fs-3 mb-4 text-center">クーポンのご利用方法</h1>
                            <p>
                                1．ふるぷら公式ECサイト上部のサイドバーにある👤＞＞プロフィールを選択してください。<br />
                                2．サブスクリプション＞＞【プランを見る】をクリックしてください。<br />
                                3．クーポンコードを利用したいプランの【詳細】をクリックしてください。<br />
                                4．【Check Out】をクリックしてください。<br />
                                5．【Linkを使わずに支払う】をクリックしてください。<br />
                                6．お支払手段・住所・プロモーションコード(チラシに記載されているクーポンコード)をご入力ください。<br />
                                7．【申し込む】を押したら、完了です。<br />
                            </p>
                </Col>
            </Row>
        </Container>
        </>
  )
}

export default Coupon